import { ref, onMounted, onUnmounted } from 'vue';
import axios from 'axios';
import { espoRpcUrl } from '@/services/config';
import { createNumberingClient } from '@/services/numbering.mjs';

export const numberingClient = createNumberingClient(async (method, params) => {
  if (!espoRpcUrl) throw new Error('numbering_not_configured');
  const { data } = await axios.post(espoRpcUrl, {
    jsonrpc: '2.0', id: 1, method, params,
  }, { timeout: 15000 });
  if (data.error) throw new Error(data.error.message || 'numbering_service_unavailable');
  return data.result;
});

const status = ref(null);
const error = ref('');
const loading = ref(false);
let pending;
let timer;
let subscribers = 0;

export function refreshNumbering() {
  if (pending) return pending;
  loading.value = true;
  pending = numberingClient.status().then(result => {
    status.value = result;
    error.value = '';
  }).catch(cause => {
    status.value = null;
    error.value = cause.message;
  }).finally(() => {
    loading.value = false;
    pending = null;
  });
  return pending;
}

export default function useEspoNumbering() {
  onMounted(() => {
    subscribers += 1;
    if (subscribers === 1) {
      refreshNumbering();
      timer = setInterval(refreshNumbering, 30000);
    }
  });
  onUnmounted(() => {
    subscribers -= 1;
    if (!subscribers) clearInterval(timer);
  });
  return { status, error, loading, refresh: refreshNumbering };
}
